import theme from "@/theme";

export const styles = {
  dialogPaper: {
    borderRadius: "20px",
    width: 560,
    maxWidth: "95vw",
    boxShadow: "0 16px 40px rgba(0,0,0,0.1)",
    border: "1px solid #E4E7E9",
  },
  title: {
    textAlign: "center" as const,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 600,
    color: "#2A2D31",
    p: "20px 24px 8px",
  },
  subTitle: {
    textAlign: "center" as const,
    fontFamily: "Inter",
    fontSize: "14px",
    color: "#6B7280",
    p: "0 24px 16px",
    padding: 0,
  },
  content: {
    pt: 0,
    pb: 0,
  },
  pickersRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    mt: "12px",
  },
  pickerCol: {
    flex: 1,
  },
  pickerLabel: {
    fontFamily: "Inter",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#9DA6B0",
    mb: "8px",
    textTransform: "uppercase" as const,
    letterSpacing: 0.6,
  },
  pill: (selected: boolean, disabled: boolean) => ({
    px: "12px",
    py: "10px",
    borderRadius: "12px",
    border: selected ? `2px solid ${theme.palette.custom.mainBlue}` : "1px solid #E4E7E9",
    backgroundColor: selected ? "#F0F6FF" : "#FFF",
    color: disabled ? "#C6CBD1" : "#2A2D31",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    userSelect: "none" as const,
    transition: "all .15s ease",
    "&:hover": !disabled && !selected ? { borderColor: "#C6D8FF", backgroundColor: "#FAFBFF" } : {},
  }),
  swapBtn: {
    width: 40,
    height: 40,
    borderRadius: "12px",
    border: "1px solid #E4E7E9",
    color: "#2A2D31",
    "&:hover": { backgroundColor: "#F7F8FA" },
  },
  errorText: {
    mt: "12px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "#B91C1C",
    textAlign: "center" as const,
  },
  actions: {
    p: "16px 24px 20px",
  },
  actionsRow: {
    display: "flex",
    gap: 1,
    width: "100%",
  },
  btnRounded: {
    borderRadius: "12px",
    width: "100%",
    "&.Mui-disabled": {
      backgroundColor: "#8BC5F4",
      color: "#fff",
    },
  },
  amountRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    mt: "4px",
    mb: "8px",
  },
  amountLabel: {
    fontFamily: "Inter",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#9DA6B0",
    textTransform: "uppercase" as const,
    letterSpacing: 0.6,
  },
  amountInput: {
    width: 200,
    "& .MuiInputBase-root": {
      height: 40,
      borderRadius: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E4E7E9",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C6D8FF",
    },
    "& .MuiInputBase-input": {
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 600,
    },
  },
  amountReadout: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "#2A2D31",
  },
} as const;
